import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=4d6e3b4c&"
import script from "./brand.vue?vue&type=script&lang=ts&"
export * from "./brand.vue?vue&type=script&lang=ts&"
import style0 from "./brand.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports